import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="text-expand"
export default class extends Controller {
  expand(event) {
    event.preventDefault()

    // Get the button that was clicked
    const button = event.currentTarget

    // Find the previous sibling element (the content to expand)
    const content = button.parentElement.previousElementSibling

    if (content) {
      // Add the expand class
      content.classList.add("team-text-expand")
      // Hide the button
      button.style.display = 'none'
    }
  }
}
